// Any ball | Snooker: the ruleset for practice and Find match (remembered in the player settings, settings.ts;
// Any ball until the player picks Snooker).
import React, {useSyncExternalStore} from "react";
import {PlayerSettings} from "../../settings";
import {RULESET_NAMES, Ruleset} from "../../shared/rules";
import "./RulesetPicker.scss";

/** The chosen ruleset (re-renders when it changes). */
export function useChosenRuleset(): Ruleset {
    return useSyncExternalStore(PlayerSettings.subscribe, () => PlayerSettings.get().ruleset);
}

/** Left to right: the default first. */
export const PICKER_ORDER: Ruleset[] = ["anyball", "snooker"];

export const RULESET_HELP: Record<Ruleset, string> = {
    snooker: "Full snooker: red then colour, colours in order, fouls give points to the opponent.",
    anyball: "Any ball (15 numbered balls): hit any ball, every pot is +1 and keeps your turn, a miss or the cue ball potted is -1. Clear the table, higher score wins.",
};

export default function RulesetPicker({value, disabled, onChange, id}: {value: Ruleset, disabled?: boolean, onChange: (r: Ruleset) => void, id?: string}) {
    return <div className={"ruleset-picker" + (disabled ? " disabled" : "")} role="radiogroup" aria-label="Rules" id={id}>
        {PICKER_ORDER.map(r =>
            <button key={r} type="button" role="radio" aria-checked={value === r} data-ruleset={r}
                    className={"ruleset-option" + (value === r ? " active" : "")} disabled={disabled}
                    title={RULESET_HELP[r]} onClick={() => { if (value !== r) onChange(r); }}>
                {RULESET_NAMES[r]}
            </button>)}
    </div>;
}
